<template>
  <v-navigation-drawer
      v-model="drawer"
      absolute
      permanent
      left
  >
    <div v-if="$route.name !== 'MapView'">
      <v-list class="pt-4">
        <v-list-item-group
          color="primary"
        >
          <v-list-item
            link
            to="/dashboard"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>ダッシュボード</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            to="/group"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>グループ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <div v-else class="pa-3">
      <v-btn-toggle
          style="width: 100%"
          dense
      >
        <v-row class="ma-0">
          <v-col cols class="pa-0">
            <v-btn
                :disabled="!sharedState.sideTab.includes('thermal')"
                class="switch-left"
                width="100%"
                @click="changeColorTab('thermal')"
                :color="tab === 'thermal' ? 'warning' : 'grey'"
            >
              サーマル
            </v-btn>
          </v-col>
          <v-col cols class="pa-0">
            <v-btn
                :disabled="!sharedState.sideTab.includes('color')"
                class="switch-right"
                width="100%"
                @click="changeColorTab('color')"
                :color="tab === 'color' ? 'success' : 'grey'"
            >
              RGB
            </v-btn>
          </v-col>
        </v-row>
      </v-btn-toggle>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              class="mb-3 mt-3 px-2"
              v-bind="attrs"
              v-on="on"
              width="100%"
          >
            <v-icon>mdi-download</v-icon>ダウンロード
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="downloadOrtho('thermal')" v-if="sharedState.sideTab.includes('thermal')">
            <v-list-item-title>サーマルオルソ画像</v-list-item-title>
          </v-list-item>
          <v-list-item @click="downloadOrtho('color')" v-if="sharedState.sideTab.includes('color')">
            <v-list-item-title>RGBオルソ画像</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="d-flex justify-center text-subtitle-2 pb-3">
        <a :href="'/report/' + $route.params.folderUuid">レポートへ</a>
      </div>
      <v-divider></v-divider>
      <div class="ml-2">
        <v-checkbox
            class="outside-checkbox"
            v-model="isFilterOn"
            label="アノテーション"
            :input-value="filter.length === 8"
            hide-details
            @change="filterAll"
        >
        </v-checkbox>
        <div class="ml-4">
          <v-checkbox
              class="checkbox mt-2 d-flex justify-center align-center"
              v-for="item in annotation_filter"
              :label="item.text"
              :value="item.value"
              v-model="filter"
              :key="item.value"
              dense
              hide-details
              @change="filterSingle"
              :disabled="item.disabled"
          >
            <template v-slot:append>
              <div class="div-rounded" :style="`background-color: ${item.color}`"></div>
            </template>
          </v-checkbox>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import {store} from "@/store";

export default {
  name: "Sidebar",
  data: () => ({
    sharedState: store.state,
    drawer: true,
    annotation_filter: [
      {
        text: 'ホットスポット',
        value: 'cell',
        color: '#FF6D00FF',
        disabled: true
      },
      {
        text: 'マルチホットスポット',
        value: 'multicell',
        color: '#FFFF00FF',
        disabled: true
      },
      {
        text: 'クラスタバイパス',
        value: 'cluster',
        color: '#D50000FF',
        disabled: true
      },
      {
        text: 'モジュール異常',
        value: 'module',
        color: '#96003DFF',
        disabled: true
      },
      {
        text: 'ストリング異常',
        value: 'string',
        color: '#40007CFF',
        disabled: true
      },
      {
        text: 'ジャンクションボックス過熱',
        value: 'junction',
        color: '#4CAF50FF',
        disabled: true
      },
      {
        text: 'ＰＩＤ現象の疑い',
        value: 'pid',
        color: '#1B5E20FF',
        disabled: true
      },
      {
        text: '影',
        value: 'shadow',
        color: '#2D79B3FF',
        disabled: true
      },
    ],
    filter: ['cell', 'multicell', 'cluster', 'module', 'string', 'junction', 'pid', 'shadow'],
    isFilterOn: true,
    tab: store.state.sideTab.includes('thermal') ? 'thermal':'color'
  }),

  methods: {
    filterAll(){
      if (this.isFilterOn){
        this.filter = ['cell', 'multicell', 'cluster', 'module', 'string', 'junction', 'pid', 'shadow']
      }
      else {
        this.filter = []
      }
      this.$root.$emit('filter', this.filter);
    },
    filterSingle(){
      this.$root.$emit('filter', this.filter);
    },
    changeColorTab(tab){
      this.tab = tab;
      this.$root.$emit('updateMapTab', tab);
    },
    downloadOrtho(type){
      this.$root.$emit('downloadOrtho', type);
    },
    changeFolderMap(){
      this.tab = store.state.sideTab.includes('thermal') ? 'thermal':'color';
      this.isFilterOn = true;
      this.filter = ['cell', 'multicell', 'cluster', 'module', 'string', 'junction', 'pid', 'shadow'];
    },
    turnOnFilter(type){
      const filter = this.annotation_filter.find(i => i.value === type);
      filter.disabled = false;
    }
  },

  created() {
    this.$root.$on('changeFolderMap', this.changeFolderMap);
    this.$root.$on('turnOnFilter', this.turnOnFilter);
  },

  beforeDestroy() {
    this.$root.$off('changeFolderMap', this.changeFolderMap);
    this.$root.$off('turnOnFilter', this.turnOnFilter);
  }
}
</script>

<style scoped>
>>>.outside-checkbox .v-label{
  font-size: 16px;
  font-weight: bold;
}
>>>.checkbox .v-label {
  font-size: 13px;
}
.switch-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.switch-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.div-rounded{
  display: inline-block;
  border: 1px solid #000000;
  border-radius:50%;
  height: 15px;
  width: 15px;
}
</style>
